/* eslint-disable */
export default {
  forward: 'Renvoyer',
  cancel: 'Annuler',
  customNumber: 'N° personnalisé',
} as const;

// @key: @#@"forward"@#@ @source: @#@"Forward"@#@
// @key: @#@"cancel"@#@ @source: @#@"Cancel"@#@
// @key: @#@"customNumber"@#@ @source: @#@"Custom number"@#@
